import React, { useEffect, useState } from 'react'
import { ColorRing } from 'react-loader-spinner';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from 'recharts';
import CustomTooltip from '../HigherLevelAnalysis/CustomTooltip';

const MIPriceMovementDataGraph = ({chartData, queryNParams, shaperedux ,caratRanges, isLoading}) => {
  const tabOptionsConfig = {
    "Shape": {
      prop_name: "shape",
      options: [
        { display: "Round", value: "0000round" },
        { display: "Princess", value: "0001princess" },
        { display: "Pear", value: "0002pear" },
        { display: "Oval", value: "0003oval" },
        { display: "Emerald", value: "0004emerald" },
        { display: "Marquise", value: "0005marquise" },
        { display: "Cushion", value: "0007cushion_brilliant" },
        { display: "Radiant", value: "0009radiant" },
        { display: "Asscher", value: "0011asscher" }
      ]
    },
    "Carat Range": {
      prop_name: "carats",
      options: [
        { display: "10.0-99.99", value: "10.0-99.99" },
        { display: "5.0-5.99", value: "5.0-5.99" },
        { display: "4.0-4.99", value: "4.0-4.99" },
        { display: "3.0-3.99", value: "3.0-3.99" },
        { display: "2.0-2.99", value: "2.0-2.99" },
        { display: "1.5-1.99", value: "1.5-1.99" },
        { display: "1.0-1.49", value: "1.0-1.49" },
        { display: "0.9-0.99", value: "0.9-0.99" },
        { display: "0.7-0.89", value: "0.7-0.89" },
        { display: "0.5-0.69", value: "0.5-0.69" },
        { display: "0.4-0.49", value: "0.4-0.49" },
        { display: "0.3-0.39", value: "0.3-0.39" },
        { display: "0.2-0.29", value: "0.2-0.29" },
        { display: "0-0.19", value: "0-0.19" },
      ]      
    },

    "Color": {
      prop_name: "color",
      options: [
        { display: "D", value: "0000d" },
        { display: "E", value: "0001e" },
        { display: "F", value: "0002f" },
        { display: "G", value: "0003g" },
        { display: "H", value: "0004h" },
        { display: "I", value: "0005i" },
        { display: "J", value: "0006j" },
      ]
    },
    
    "Clarity": {
      prop_name: "clarity",
      options: [
        { display: "IF", value: "0001if" },
        { display: "VVS1", value: "0002vvs1" },
        { display: "VVS2", value: "0003vvs2" },
        { display: "VS1", value: "0004vs1" },
        { display: "VS2", value: "0005vs2" },
        { display: "SI1", value: "0006si1" },
        { display: "SI2", value: "0007si2" },
        { display: "I1", value: "0009i1" },
        
      ]
    },
    // "Location": {
    //   prop_name: "enumlocation",
    //   options: [
    //     { display: "USA", value: "0001usa" },
        
    //   ]
    // },
    
  };
  const renderSelectedValues = (tabKey) => {
    const selectedOption = tabOptionsConfig[tabKey]?.options.find(
      (option) => option.value === queryNParams[tabKey.toLowerCase()]
    );
    return selectedOption ? selectedOption.display : '';
  };
 
   const [showMin, setShowMin] = useState(false);
      const [showMax, setShowMax] = useState(false)
  
      const toggleMinLine = () => {
        setShowMin(prevState => {
          const newState = !prevState;
          return newState;
        });
      };
      
      const toggleMaxLine = () => {
        setShowMax(prevState => {
          const newState = !prevState;
          return newState;
        });
        
      }; 
  
      useEffect(() => {
        // This will run whenever showMin or showMax changes
       
        
      }, [showMin, showMax]);
  
  return (
    <div className="w-full min-h-[480px] bg-white py-4 px-2 border-y md:border-y-0 md:border-x shadow-md rounded-md border-gray-200">
            {/* <h1 className="text-xl font-bold mb-2">Main Display</h1> */}
            <p className="mb-1 flex justify-center items-center gap-2">
              <span className="font-medium text-center"><strong>{renderSelectedValues('Shape')}</strong></span> 
              <span className="font-medium text-center"><strong>{caratRanges}</strong></span> 
              <span className="font-medium text-center"><strong>{renderSelectedValues('Color')}</strong></span> 
              <span className="font-medium text-center"><strong>{renderSelectedValues('Clarity')}</strong></span> 
              <span className="font-medium text-center"><strong>{renderSelectedValues('Location')}</strong></span> 
              {/* <span className="font-medium"><strong>:</strong></span> 
              <span className="font-medium w-[76px] text-start"> {queryNParams.clarity}</span>  */}
            </p>

            
            {queryNParams.color && queryNParams.clarity && (
        <div className="mt-4">
          {isLoading ? (
            <div className="flex justify-center items-center h-full">
              <ColorRing
                visible={true}
                height="60"
                width="60"
                ariaLabel="blocks-loading"
                colors={["#00319f", "#2e56b1", "#5c7bc2", "#8aa1d3", "#b2c1e2"]}
              />
            </div>
          ) : chartData && chartData.length > 0 ? (
            <div className="w-full h-96">

             <ResponsiveContainer>
                  <LineChart data={chartData} margin={{ top: 30, right: 40, left: 0, bottom: 0 }}>
                    <CartesianGrid strokeDasharray="3 3" stroke="#eee" />
                    <XAxis
                      dataKey="week"
                      tick={{ fontSize: 13 }}
                      tickFormatter={(value) => {
                        const [year, month, day] = value.split("-");
                        return `${month}/${day}/${year.slice(2)}`;
                      }}
                    />
                    <YAxis
                      yAxisId="left"
                      domain={['auto', 'auto']}
                      tickFormatter={(value) => `${value}%`}
                      tick={{ fontSize: 13 }}
                    />
                    <YAxis
                      yAxisId="right"
                      orientation="right"
                      domain={['auto', 'auto']}
                      tickFormatter={(value) => `${value}`}
                      tick={{ fontSize: 13 }}
                    />
                    <Tooltip
                      formatter={(value) => `${value}`}
                      content={<CustomTooltip />}
                      labelStyle={{ fontWeight: 'bold' }}
                    />
                    <Legend verticalAlign="bottom" height={30} />
                    {/* <Line
                      yAxisId="left"
                      type="basis"
                      dataKey="price_change_10th"
                      stroke="#8884d8" 
                      strokeDasharray="4 4"
                      strokeWidth={2.5}
                      dot={false}
                      name="Min"
                      hide={!showMin} 
                    />
                    <Line
                      yAxisId="left"
                      type="basis"
                      dataKey="price_change_90th"
                      stroke="#82ca9d" 
                      strokeDasharray="4 4" 
                      strokeWidth={2.5}
                      dot={false}
                      name="Max"
                      hide={!showMax} 
                    /> */}
                    <Line
                      yAxisId="left"
                      type="monotone"
                      dataKey="price_change"
                      stroke="#1f2d3d"
                      strokeWidth={2.5}
                      dot={false}
                      name="Price Change"
                    />
                    <Line
                      yAxisId="right"
                      type="monotone"
                      dataKey="overhang"
                      stroke="#65b0ac"
                      strokeWidth={2.5}
                      dot={false}
                      name="Inventory Overhang"
                    />
                  </LineChart>
            </ResponsiveContainer>
            {/* <div className="flex items-center justify-center gap-6 mt-2"> */}
          {/* Min checkbox */}
                {/* <div className="flex items-center gap-1">
                  <label htmlFor="showMinCheckbox" className="flex items-center gap-2 cursor-pointer">
                    <span style={{ 
                      width: "12px", 
                      height: "2px", 
                      backgroundColor: "#8884d8", 
                      display: "inline-block",
                    }}></span>
                    <span>Min</span>
                  </label>
                  <input
                    className="cursor-pointer w-3 h-3 z-99 relative"
                    type="checkbox"
                    id="showMinCheckbox"
                    checked={showMin}
                    onChange={toggleMinLine}
                  />
                </div> */}
                
                {/* Max checkbox */}
                {/* <div className="flex items-center gap-1">
                  <label htmlFor="showMaxCheckbox" className="flex items-center gap-2 ">
                    <span style={{ 
                      width: "12px", 
                      height: "2px", 
                      backgroundColor: "#82ca9d", 
                      display: "inline-block",
                    }}></span>
                    <span>Max</span>
                  </label>
                  <input
                    className="cursor-pointer w-3 h-3 z-99 relative"
                    type="checkbox"
                    id="showMaxCheckbox"
                    checked={showMax}
                    onChange={toggleMaxLine}
                  />
                </div> */}
            {/* </div>   */}
            </div>
            ) : (
              <div className="flex justify-center">
                Market Information not available.
              </div>
            )}
          </div>
        )}
      </div>
  )
}

export default MIPriceMovementDataGraph